/**
 * Dynamic Journey Selection Utility
 *
 * TODO: - Remove this entire file after unified bags rollout is complete.
 *
 * This module handles dynamic funnel journey selection based on whether a bundle
 * includes hold bags or not:
 * - Bundles WITH hold bags (Extra, Extra+) → 2-step journey (Cabin Bags + Hold Bags pages)
 * - Bundles WITHOUT hold bags (Light, Smart+) → 1-step unified journey (single Luggage page)
 *
 * Feature is controlled by the 'funnelDynamicJourneyUnifiedBagsPage' feature flag.
 */

import { cookieNames, readCookie, setCookie } from './cookie-utils';
import { BundleData } from 'server-schemas/channels/basket';

const UNIFIED_BAGS_SUFFIX = 'UnifiedBags';

export const getBaseJourney = (journey = ''): string => journey.replace(new RegExp(`${UNIFIED_BAGS_SUFFIX}$`), '');

export const hasUnifiedBagsSuffix = (journey = ''): boolean => journey.endsWith(UNIFIED_BAGS_SUFFIX);

export const updateFunnelJourneyCookieBasedOnBundle = (bundleData: BundleData): void => {
  if (!bundleData?.length) {
    return;
  }

  const currentJourney = readCookie(cookieNames.Availability.ejJourney);
  if (!currentJourney) {
    return;
  }

  const baseJourney = getBaseJourney(currentJourney);
  const newJourney = `${baseJourney}${UNIFIED_BAGS_SUFFIX}`;

  if (newJourney !== currentJourney) {
    setCookie(cookieNames.Availability.ejJourney, newJourney, {
      path: '/',
      sameSite: 'Lax',
      secure: true,
      domain: cookieNames.Availability.ejJourneyDomain
    });
  }
};

/**
 * Preserves the UnifiedBags suffix when updating journey data.
 * Used by funnel-journey-store to keep cookie and localStorage in sync.
 *
 * @param newJourney - The new journey value being set
 * @returns The journey with preserved suffix if applicable
 */
export const applyUnifiedBagsSuffixConditionally = (newJourney: string): string => {
  if (!newJourney) {
    return newJourney;
  }

  const currentEjJourney = readCookie(cookieNames.Availability.ejJourney) || '';
  const currentBaseJourney = getBaseJourney(currentEjJourney);
  const newBaseJourney = getBaseJourney(newJourney);

  if (currentBaseJourney === newBaseJourney) {
    return hasUnifiedBagsSuffix(currentEjJourney) ? `${newBaseJourney}${UNIFIED_BAGS_SUFFIX}` : newBaseJourney;
  }

  return newJourney;
};
